import type { TourDefinition } from "../types";

/**
 * First-run global tour. Fires once after the user first lands on any
 * authenticated route. Introduces the core navigation primitives (sidebar,
 * workspace switcher, floating help button) so subsequent per-page tours feel
 * familiar.
 */
export const welcomeTour: TourDefinition = {
  id: "welcome",
  label: "Welcome to Zitiu",
  description: "A 60-second intro to the studio layout",
  // Fires on any authenticated /app route.
  routeMatch: /^\/app(\/|$)/,
  estimatedSeconds: 60,
  steps: [
    {
      target: "body",
      placement: "center",
      title: "Welcome to Zitiu 👋",
      body: "Let's take a quick look at the studio so you know where everything lives. This takes under a minute — you can skip anytime.",
    },
    {
      target: '[data-tour="sidebar"]',
      placement: "right",
      title: "Main navigation",
      body: "Jump between Studio, Asset Library and Product Library here. Everything you create is scoped to the active workspace.",
    },
    {
      target: '[data-tour="workspace-switcher"]',
      placement: "bottom-start",
      title: "Your workspace",
      body: "Switch between workspaces or invite teammates. All products and visuals belong to the workspace shown here.",
    },
    {
      target: '[data-tour="help-button"]',
      placement: "left",
      title: "Need a refresher?",
      body: "This help button stays in the corner on every page. Click it to replay the tour for whatever screen you're on, or browse all tours.",
    },
    {
      target: "body",
      placement: "center",
      title: "You're all set",
      body: "Start by adding a product, then open Studio to make visuals of it. I'll be here when you need me.",
    },
  ],
};
